import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './kpi-row.types';
import * as constants from './kpi-row.constants';

export const storeKpiRow = generateStoreResourceAction<types.IKpiRow>(constants.STORE_KPI_ROW);
export const clearKpiRow = generateClearResourceAction(constants.CLEAR_KPI_ROW);
